<template id="mdm-form-page">
  <section>
    <div class="row">
      <div class="col-md-10 col-lg-12 text-center mt-3 mb-5">
        <div class="card">
          <div class="card-header text-left">
            <i class="fa fa-file"></i> {{formTitle}}

          </div>
          <div class="card-body">

            <!--Filters-->
              <div>
                  <table >
                      <tr>
                          <th class="thead-dark" align="center" v-for="key in dimSelectDpValues" v-bind:key="key"> {{key}}</th>
                          <b>Generic Search</b>
                      </tr>
                      <tr>
                          <td v-for="(key,index) in dimSelectDpValues" v-bind:key="key">
                              <v-select multiple v-bind:key="key" v-model="selectVal[rowsDataDimKeys[index]]" :options="options[rowsDataDimKeys[index]]">
                                  <option >All</option>
                                  <option :value="option" v-for="option in options[rowsDataDimKeys[index]]" :key="option">{{ option }}</option>
                              </v-select>
                          </td>
                          <input type="text" v-model="filterValue" placeholder="Search">
                      </tr>
                  </table>
              </div>
              <br>
            <!--table-->
              <div class="grid-container">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead class="thead-dark">
                <tr class="text-center">
                    <th>Action
                    <a><i class="fa-sort" ></i></a>
                    </th>
                  <th v-for="(col, index) in columns" v-bind:key="index">
                    {{col}}
                    <a href="#" @click="sortBy(Rcolumns[index])">
                      <i class="fa" v-bind:class="Rcolumns[index]===sortKey ? (sortOrder === 'asc' ?  'fa-sort-amount-down-alt' : 'fa-sort-amount-up-alt') : 'fa-sort' " v-bind:style="[Rcolumns[index]===sortKey ? {'color':'Gold'} : {'color':'White'}]" ></i>
                    </a>
                  </th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(rowd,index) in filteredItems" >
                    <tr v-bind:key="index">
                        <td class="text-center">
                            <div class="btn-group">
                                <button class="btn btn-sm btn-outline-primary" v-b-tooltip.hover
                                        title="Add"
                                        v-on:click="showRow(rowd.syspk)">
                                    <i class="fa fa-plus"></i>
                                </button>
                                <button class="btn btn-sm btn-outline-warning" size="sm"
                                        v-b-tooltip.hover
                                        title="Edit" v-on:click="edit(rowd.syspk)">
                                    <i class="fa fa-edit"></i>
                                </button>
                            </div>
                        </td>
                        <td :class="{'text-right' : col.startsWith('rm'),'text-left' : col.startsWith('rd') || col.startsWith('rr'), 'text-danger':rowd['rm7']>40}" v-for="col in Rcolumns" v-bind:key="col">{{rowd[col]}}</td>
                    </tr>
                    <template v-if="showInputfield && rowd.syspk == editableId">
                        <tr :key="rowd.index"><h6>Edit Record</h6>
                           <button class="btn btn-sm btn-outline-primary"
                                    v-on:click="validateEditRow(rowd)"
                                    v-b-tooltip.hover
                                    title="Validate">
                               <i class="fas fa-tasks"></i>
                                <!--<i class="fa fa-save"></i>-->
                           </button>

                            <button class="btn btn-sm btn-danger" v-on:click="hideR(rowd)"
                                    v-b-tooltip.hover
                                    title="Cancel">
                                <i class="fa fa-window-minimize"></i>
                            </button>

                        </tr>
                        <tr :key="rowd.index" style="background-color: #FFF9DF;font-size: 12px">
                    <!--<tr v-bind:key="index+'i'"  v-if="false">-->
                            <th></th>
                        <th v-for="(col, index) in columns" v-bind:key="index">
                        <label>{{col}}</label>
                        <input  type="text"
                                v-model="rowd[Rcolumns[index]]"
                               class="form-control" :disabled="columnsInfo[index]['fieldIsEditable']"
                               >
<!--                            v-if="columnsInfo[index]['inputFieldType']=='Enter Only'"-->

                    </th>
                    </tr>
                    </template>
                    <template v-if="showInput && rowd.syspk == savetableId">
                        <tr :key="rowd.index"><h6>New Record</h6>
                            <button class="btn btn-sm btn-outline-primary"
                                    v-on:click="validateInsertRow(rowEdit)"
                                    v-b-tooltip.hover
                                    title="Validate">
                                <i class="fas fa-tasks"></i>
                            </button>

                            <button class="btn btn-sm btn-danger" v-on:click="hideR(rowd)"
                                    v-b-tooltip.hover
                                    title="Cancel">
                                <i class="fa fa-window-minimize"></i>
                            </button>
                        </tr>
                        <tr :key="rowd.index" style="background-color: #FFF9DF;font-size: 12px">
                            <!--<tr v-bind:key="index+'i'"  v-if="false">-->
                            <th></th>
                            <th v-for="(col, index) in columns" v-bind:key="index">
                                <label>{{col}}</label>

                                <input  :type="columnsInfo[index]['fieldValidationType']"
                                       v-if="columnsInfo[index]['inputFieldType']=='Enter Only'"
                                        v-on:change="handleValidateFunc(columnsInfo[index]['fieldValidationType'],rowEdit[Rcolumns[index]])"
                                       required

                                        :name="columnsInfo[index]['fieldValidationType']"
                                       v-model="rowEdit[Rcolumns[index]]"
                                       class="form-control" :disabled="col=='S.No'?true:false">
                                <span v-if="columnsInfo[index]['fieldValidationType']=='GSTINValidate'"  >
                                        <div>{{message}}   </div>
                                        <div>{{name}}   </div></span>
                                <span v-if="columnsInfo[index]['fieldValidationType']=='email'"  >
                                        <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
                                    </span>
                                <!--<template v-if="col=='Code'">
                                <input type="text"
                                       id="txtmfrCode"
                                       v-on:change="col=='Code' ?ValidateMFR():''"
                                       oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                       maxlength = "6"
                                       v-if="columnsInfo[index]['inputFieldType']=='Enter Only'"
                                       required
                                       v-model="rowEdit[Rcolumns[index]]"
                                       class="form-control" :disabled="false">
                                <span v-if="col=='Code'" id="lblmfrCode" class="error">Invalid Format, Please enter in the format 'AA9999'</span>
                                </template>-->

                                <!--<template v-if="columnsInfo[index]['fieldValidationType']=='email'">
                                    <input type="email"
                                           required
                                           v-if="columnsInfo[index]['inputFieldType']=='Enter Only'"
                                           v-validate="" name="email"
                                           v-model="rowEdit[Rcolumns[index]]"
                                           class="form-control" :disabled="false" >

                                    <span v-if="columnsInfo[index]['fieldValidationType']=='email'"  >
                                        <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
                                    </span>
                                </template>-->
                                <br>
                                <v-select
                                        v-if="(col!=='Mfg. Name' && col!=='Brand Name') && columnsInfo[index]['inputFieldType']=='Select Only'"
                                        :options="listboxData[Rcolumns[index]]"
                                        v-model="rowEdit[Rcolumns[index]]"
                                >
                                    <option >Select State</option>
                                    <option v-for="rl in listboxData[Rcolumns[index]]" v-bind:key="rl">{{rl}}</option>
                                </v-select>
                                <v-select
                                        v-if="col=='Mfg. Name' && columnsInfo[index]['inputFieldType']=='Select Only'"
                                        :options="mfgName(rowEdit[Rcolumns[index-1]])"
                                        v-model="rowEdit[Rcolumns[index]]"
                                >
                                    <option >Select State</option>
                                    <option v-for="rl in listboxData[Rcolumns[index]]" v-bind:key="rl">{{rl}}</option>
                                </v-select>
                                <v-select
                                        v-if="col=='Brand Name' && columnsInfo[index]['inputFieldType']=='Select Only'"
                                        :options="brandName(rowEdit[Rcolumns[index-1]])"
                                        v-model="rowEdit[Rcolumns[index]]"
                                >
                                    <option >Select State</option>
                                    <option v-for="rl in listboxData[Rcolumns[index]]" v-bind:key="rl">{{rl}}</option>
                                </v-select>

                            </th>
                        </tr>
                    </template>

                </template>
                </tbody>
              </table>
            </div>
              </div>
          </div>
          </div>
        </div>
      </div>
      <b-modal id="modal-xl" size="xl" ref="validate-update-row-box" @ok="updateRecord()" :title="formTitle">

          <b-form-group  :label="rowd['syspk']==20?'Check the rows for duplication':'No Matching Record found'">
              <!--<b-form-input
                      id="name-input"
                      v-model="name"
                      :state="nameState"
                      required
              ></b-form-input>-->
              <div class="table-responsive">
              <table class="table table-bordered">
                  <thead class="thead-dark">
                  <tr class="text-center">

                      <th v-for="(col, index) in columns" v-bind:key="index">
                          {{col}}
                      </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>

                      <td style="color:blue" v-for="(col, index) in columns" v-bind:key="index">
                          {{rowd[Rcolumns[index]]}}

                      </td>
                  </tr>
                  <template v-if="rowd['syspk']==20">
                  <tr v-for="er in 2" v-bind:key="er">

                      <td style="color:darkgoldenrod" v-for="(col, index) in columns" v-bind:key="index">
                          {{rowd[Rcolumns[index]]}}
                      </td>


                  </tr>
                  </template>

                  </tbody>
              </table>

              </div>
          </b-form-group>

      </b-modal>
      <b-modal id="modal-xl" size="xl" ref="validate-insert-row-box" @ok="insertRecord()"  ok-title="Accept" :title="formTitle" >

          <b-form-group  :label="dedupData.length>0?'Check the rows for duplication':'No Possible Duplicate Record found. Please validate and accept for insertion'">
              <!--<b-form-input
                      id="name-input"
                      v-model="name"
                      :state="nameState"
                      required
              ></b-form-input>-->
              <div class="table-responsive">
                  <table class="table table-bordered">
                      <thead class="thead-dark">
                      <tr class="text-center">

                          <th v-for="(col, index) in columns" v-bind:key="index">
                              {{col}}
                          </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>

                          <td style="color:blue" v-for="(col, index) in columns" v-bind:key="index">
                              {{rowdIns[Rcolumns[index]]}}

                          </td>
                      </tr>
                      <template v-if="dedupData.length>0">
                          <tr v-for="er in dedupData" v-bind:key="er">

                              <td style="color:darkgoldenrod" v-for="(col, index) in columns" v-bind:key="index">
                                  {{er[Rcolumns[index]]}}
                              </td>


                          </tr>
                      </template>

                      </tbody>
                  </table>

              </div>
          </b-form-group>

      </b-modal>
      <b-modal ref="success-box" :hide-footer="true" :title="formTitle" cancel-disabled ok-disabled>
          <b-form-group label="">
              <h4 style="color:darkblue">Record Added Successfully.</h4>
          </b-form-group>
      </b-modal>
  </section>

</template>

<script>
import axios from 'axios'
import _ from 'lodash'


export default {
  name: 'simple-report-page',

  data: function() {
    return {
        showInputfield: '',
        editableId:[],
        showInput: '',
        savetableId:[],
        hideRow:[],
        rowd:[],
        rowdIns:[],
        columnsInfo:[],
        rowEdit:[],
        listboxData:[],
        dedupData:[],
        mfgNameList:[],
        brandNameList:[],

        message:'',
        name:'',


        output: [ ],
      formTitle:'',
      columns:[],
      keys: [ ],
      rowsdata: [ ],
      sortKey: [],
      sortOrder: ['asc'],
      dimSelectDpValues: [],
      rowsDataDimKeys: [],
      filterValue: '',
      // This is much simpler if the select is it's own component.
      selectVal: {
        isActive: undefined,
        age: undefined,
        first_name: undefined,
        last_name: undefined
      }
    }
  },
  created: function () {
    //this.loadCustomerSales()
    this.loadReportConfig()
    this.listenToRouter()
  },
  computed: {
    "Rcolumns": function columns() {
      if (this.rowsdata.length == 0) {
        return [];
      }
      return Object.keys(this.rowsdata[0])
    },
    "orderedData": function () {
      let result=this.rowsdata;
      if (this.filterValue) {
        result = result.filter(item => item.rd2.includes(this.filterValue));
      }
      return _.orderBy(result, this.sortKey, this.sortOrder)
    },
      mfgName() {
      return (key1) => {
          console.log("mfg code passed",key1,this.mfgNameList.filter(f=>f.c_mfac_code=='MF0001')[0].c_mfac_name)
            if(key1){
               return [this.mfgNameList.filter(f=>f.c_mfac_code==key1)[0].c_mfac_name]
            }
            else
          return null

      }
      },
      brandName(){
          return (key1) => {
              console.log("mfg code passed",key1)
              if(key1){
                  return [this.brandNameList.filter(f=>f.c_brand_code==key1)[0].c_brand_name]
              }
              else
                  return null

          }
      },
    filteredItems() {
      let result = this.rowsdata.filter(item => {
        let keep = true;

        // This is a basic equality filter. What I did in the actual code was to have an object with filter functions for each key. If a key was missing, it defaulted to straight equality.
        this.rowsDataDimKeys.forEach(key => {

          if(this.selectVal[key]){
            // console.log("filter ", this.selectVal,this.selectVal[key].length==0)
            keep =
                keep &&
                (this.selectVal[key].length==0  ||
                    //item[key] === this.selectVal[key]); // true && (false ||
                    this.selectVal[key].includes(item[key])); // true && (false ||
          }

        });

        return keep;
      });
      // let result = this.rowsdata;
      if (this.filterValue) {
        /* Filters the report Data based on the entered value in the generic search box
           loop over the keys of the inner object and use Array.some()
           It will work for any number of keys of any name so no need to get depend on the keys
           to get the match of the searched text use includes()
           to make the search non case sensitive use toLowerCase()
           to avoid NULL values in filtering excluded null values by taking !=Null and with && operator
           Numeric values gave obj[key].includes is not function error so converted them to string using toString()
        */
        result = result.filter(obj =>
            Object.keys(obj)
                .some(key => (obj[key] != null ) && obj[key].toString().toLowerCase().includes(this.filterValue.toLowerCase()))

        );


      }
      return _.orderBy(result, this.sortKey, this.sortOrder)
    },
    getValues() {
      return (key1, x) => {
        // console.log("getValues ====> item", key1, x)
        var filteredData = this.example.filter((item) => {

          for (let kkk in x) { // loop over the keys of x
            //console.log("getValues >>>> ",kkk)

            if (x[kkk] && x[kkk].length > 0) { //check the value of each key is undefined/NULL or not
              //  console.log("getValues ,,,,",x[kkk],x[kkk].includes("All"))

              if (!x[kkk].includes('All')) { // check the value of the key doesn't contains All as a value
                // console.log("getValues,,,,", item[kkk], x[kkk])
                if (item[kkk] === undefined || !x[kkk].includes(item[kkk])) {

                  return false;
                }
              }
            }
            //  console.log("not entered if")
          }
          return true;
        });

        var whereClause='1==1 '
        for (let kkk in x){
          // console.log("kkk x ",kkk, x,x[kkk],whereClause + ' && ! x[kkk]'+ '.includes("item["' + kkk + '"]) ')
          if (x[kkk] && x[kkk].length > 0 && x[key1] && x[key1].length>0) { //check the value of each key is undefined/NULL or not
            if(kkk ==key1){ // check if it is for the passed key then make it as not in
              whereClause = whereClause + ' && !x["'+kkk+'"]' + '.includes(item["' + kkk + '"]) '
            }
            else{ //if not append and clause
              whereClause = whereClause + ' && x["'+kkk+'"]' + '.includes(item["' + kkk + '"])'
            }

          }
          else if(x[key1] && x[key1].length<=0){
            whereClause = whereClause + " && 1==2 "
          }
        }
        var example1 = _.clone(this.example)

        var invertFilteredData = example1.filter((item) => {

          if(eval(whereClause) && item){
            return true;
          }
          else{
            return false
          }

        })
        var firstArray = _.uniq(filteredData.map(kv => kv[key1]))
        var secondArray = []
        if(x[key1] && x[key1].length>0){
          secondArray= _.uniq(invertFilteredData.map(kv => kv[key1]))
        }

        var unionArray = _.union(firstArray,secondArray)
        console.log("where clause",whereClause, x,key1,secondArray,invertFilteredData)
        return unionArray.sort(); //gets the unique values from the filteredData by mapping the passed key and sort the values in ascending order

//        console.log("where clause", x,key1)
      }

    },

    options() {
      // This could be simplified if the select was it's own component.
      const options = {};
      this.rowsDataDimKeys.forEach(key => {
        const vals = this.rowsdata.map(item => item[key]);
        console.log("Options Data Vals",vals);
        // Cheap and efficient unique.
        options[key] = Array.from(new Set(vals)).sort();
        console.log("Distinct Options Data ",options[key]);
      });

      return options;
    }
  },
  methods: {
    sortBy: function(key) {
      console.log("The sort Key is ",key)
      if (key == this.sortKey) {
        this.sortOrder = (this.sortOrder == 'asc') ? 'desc' : 'asc';
        this.sortKey=key;
      } else {
        this.sortKey = key;
        this.sortOrder = 'asc';
      }
    },
      handleValidateFunc(fncName, value) {
          console.log("Handle function called with func name", fncName,value)
        if(fncName){
            this[fncName](value)
        }

      },

    //Get Request
    /*loadCustomerSales: function () {
      axios.get('/api/v_retailer_monthly')
        .then(res => {
          this.rowsdata = res.data
          console.log('Test', this.rowsdata)
        }, err => {
          console.log('Error fetching data', err)
        })
    },*/
      sendEmail:function() {
          this.$loadScript("https://smtpjs.com/v3/smtp.js")
              .then(() => {
                  window.Email.send({
                      Host: "mail.compegence.com",
                      Username: "muin.shariff@compegence.com",
                      Password: "Mu!nYEs#%76@shineS",
                      To: 'abdur.rahman@compegence.com,muin.shariff@compegence.com',
                      From: "muin.shariff@compegence.com",
                      Subject: "Request:MDM Approval",
                      Body: "Please check the Approval window for a new record addition. Validate and Approve.",
                  }).then(
                      alert("mail sent successfully")
                  )
              })
},

      ValidateMFR: function() {

          let txtmfrCode = document.getElementById("txtmfrCode");
          let lblmfrCode = document.getElementById("lblmfrCode")
          console.log("Entered validate MFR code",txtmfrCode.value)
          let regex = /([A-Z]){2}([0-9]){4}$/;
          if (regex.test(txtmfrCode.value.toUpperCase())) {
              lblmfrCode.style.visibility = "hidden";
              return true;
          } else {
              lblmfrCode.style.visibility = "visible";
              return false;
          }
      },
    listenToRouter: function () {
      let $this = this
      this.$router.afterEach(function (from, to) {
        console.log(`router moved to ${from.path} from ${to.path}`)
        //console.log(`router moved to ${from.path} from ${to.path}, page viz = ${$this.rows.length}`)
        $this.rowsdata = []
        $this.headerColumns= []
        setTimeout(() => {
          $this.loadReportConfig()
        }, 300)

      })
    },
      //Show Edit Input Field
      edit: function (syspk) {
          console.log('Entered into edit function', syspk)
          this.showInputfield = true
          this.editableId = syspk
      },
      //Show Row
      showRow: function (syspk) {
          console.log('Entered into add function',syspk)
          this.showInput = true
          this.savetableId = syspk

      },
      //High Light Selected Row
      toggle(syspk) {
          /* const index = this.opened.indexOf(id)*/
          this.opened.push(syspk)
      },
      show: function () {
          this.$modal.show('hello-world')
      },
      hide: function () {
          this.$modal.hide('hello-world')
      },
      //Hide Add record or save record
      hideR: function (syspk) {
          if (this.savetableId == syspk) {
              this.savetableId = null
              this.editableId = null
          } else {
              this.savetableId = syspk
              this.editableId = syspk
          }

          this.rowEdit=[]
      },
      validateEditRow:function(row){
        this.rowd=row
        console.log("Entered validate Edit function",row)
        this.$refs["validate-update-row-box"].show();
      } ,
      validateInsertRow:function(row){
          this.rowdIns=row
          axios.post("/api/fetchDataAnySqlWithParam/SQL734",[row.c_name]).then(
              res=>{
                  console.log("API response",res.data)
                  this.dedupData=res.data
              }
          ), err =>{
              console.log("Error fetching data",err.response)
          }
          console.log("Entered validate insert function",row.c_name)
          this.$refs["validate-insert-row-box"].show();
      } ,
      updateRecord:function(){
          let updObj = Object.assign({}, this.rowd)
          console.log("check the type of update Record",updObj,this.rowd)
          axios.post('/api/mdm-form-update/'+this.$route.params.submenuId,updObj).then(res=>{
                  console.log("Entered mdm-form-update API",res)
                  this.loadReportConfig()
          })
              .catch(err =>{
                  console.log("Error in mdm-form-inser API",err)
              })

          console.log("Entered validate update function",this.rowd)
          this.$refs["success-box"].show();
      },
      insertRecord:function(){
          let insObj = Object.assign({}, this.rowdIns)
          console.log("Entered validate insert function",insObj)
          axios.post('/api/mdm-form-insert/'+this.$route.params.submenuId,insObj).then(res=>{
              console.log("Entered mdm-form-insert API",res)
              this.loadReportConfig()
              this.$loadScript("https://smtpjs.com/v3/smtp.js")
                  .then(() => {
                      window.Email.send({
                          Host: "mail.compegence.com",
                          Username: "muin.shariff@compegence.com",
                          Password: "Mu!nYEs#%76@shineS",
                          // To: 'abdur.rahman@compegence.com,muin.shariff@compegence.com,nagaraj.kulkarni@gmail.com',
                          To: 'abdur.rahman@compegence.com',
                          From: "muin.shariff@compegence.com",
                          Subject: "Request:MDM Approval",
                          Body: "Please check the Approval window for a new record addition. Validate and Approve.",
                      }).then(
                          alert("Approval Request Mail sent successfully")
                      )
                  })
          })
          .catch(err =>{
              console.log("Error in mdm-form-inser API",err)
          })
          console.log("Entered validate insert function",this.rowdIns)
          this.$refs["success-box"].show();
      },
      fetchListbox: function(sql){
          var listboxData=[]
          axios.post('/api/fetchDataWithParam/' + sql + '/Any',{}).then(
              res=>{
                  listboxData =res.data.rowsdata


              },
              err => {
                  console.log('Error Fetching data', err)
              }

              )
          console.log("response of listbox SQL",listboxData)
          return listboxData;

      },
      GSTINValidate:function(gstinNum)
      {
          let url='https://sheet.gstincheck.co.in/check/' + '0739c4914d38e88bcb6346fa805800b4' + '/' + gstinNum
          axios.get(url)
              .then(res => {
                  this.result = res
                  console.log("results",this.result)
                  this.message=res.data.message
                  this.name=res.data.data.tradeNam
              }, err => {
                  console.log('Error in record', err)
              })
      },
    loadReportConfig: function () {
      console.info('loading summary',this.$route.params.submenuId)
      let menuParam = this.$route.params.submenuId
      //  let submenuParam = this.$route.params.submenuId

      //Get Request
      axios.get('/api/formConfigColumn/'+ menuParam )
          //           axios.get('/api/reportConfigColumn/'+ menuParam +'/'+submenuParam)
          .then(res => {
            this.apiData = res.data
            this.rowsdata = this.apiData.rowsData
            this.formTitle = this.apiData.columns[0].formName
            this.columnsInfo = this.apiData.columns
            this.columns = this.apiData.columns.map(function (el) { return el.formFieldDisplay; })
            console.log('ReportConfigRes',this.apiData, this.apiData.columns[0].fieldIsNullable)
            var rowsDataKeys = Object.keys(this.rowsdata[0])
            this.rowsDataDimKeys = rowsDataKeys
            this.dimSelectDpValues = this.columns
            console.log('Dimension variables Keys',this.rowsDataDimKeys)
            console.log('Data for Report',this.rowsdata)
            console.log('Dimension variables Keys',this.dimSelectDpValues)
            //console.log('Report Title',this.apiData.columns[0].repName)
            //console.log('Report headers',this.nameArray)
            const sorted = this.rowsdata.map(person => {
              let rtn = {}
              this.rowsDataDimKeys.forEach(key => {
                rtn[key] = person[key]
              })
              return rtn
            })
            this.example=[... new Set(sorted.map(JSON.stringify))].map(JSON.parse)
            //console.log("Distinct values of report data",sorted)

              // Listbox Data call
              let selectOnlyFields= this.columnsInfo.filter(k=>k.inputFieldType=='Select Only')
              selectOnlyFields.forEach(s=>{
                  console.log("select listbox data",s.fieldSelectListboxSql)
                  axios.post('/api/fetchDataWithParam/' + s.fieldSelectListboxSql + '/Any',{}).then(
                      res=>{
                          let values = res.data.rowsData.map(item => item[s.formColumnName])
                          console.log("select listbox data",s.fieldSelectListboxSql,res.data.rowsData)
                          this.listboxData[s.formColumnName]=values
                          if(s.fieldSelectListboxSql=='SQL731'){
                              this.mfgNameList = res.data.rowsData
                              console.log("Mfg names list",this.mfgNameList,this.mfgNameList.filter(f=>f.c_mfac_code=='MF0001'))
                          }
                          if(s.fieldSelectListboxSql=='SQL732'){
                              this.brandNameList = res.data.rowsData
                              console.log("brand names list",this.brandNameList)
                          }

                      },
                      err => {
                          console.log('Error Fetching data', err)
                      })
              })
              console.log("select only fields",this.listboxData);

          }, err => {
            console.log('Error Fetching data', err)
          })


      /*               //Get Request
                      axios.get('/api/reportConfigColumn/'+ menuParam +'/G01')
                      .then(res => {
                      this.drilldowndata = res.data
                      var columns = this.drilldowndata.columns
                      //var rowsdata = this.drilldowndata.rowsdata
                      console.log("API Response",this.drilldowndata)
                      var drilldownlevels = [...new Set(columns.map(dl => dl.drilldownLevel))] //... is the spread operator, which will expand the set values into an array.
                      var levelColumns = []
                      var headerColumns = []
                      for (var i=1; i<=drilldownlevels.length; i++)
                      {
                          var value ='level'+i
                          levelColumns[i] = columns.filter( ind => ind.drilldownLevel ==value)
                          headerColumns[i] = levelColumns[i].map(function (el) { return el.headerColumnDisplay;})
                      }
                      //this.headerColumnsDisplay = this.apiData.columns.map(function (el) { return el.headerColumnDisplay; })
                      console.log("Drilldown data level1",headerColumns[1])
                      console.log("Drilldown data level2",headerColumns[2])
                      console.log("Drilldown data level3",headerColumns[3])

                      }, err => {
                      console.log('Error Fetching data', err)
                      })

                     //Post Request
                     const params = new URLSearchParams();
                     params.append('param1', 'value1');
                     params.append('param2', 'value2');
                     axios.post('/api/testparams', params)
                     //axios.post('/api/reportConfigColumn/'+ menuParam +'/G01')
                     .then(res => {
                      this.string = res.data
                     //var columns = this.drilldowndata.columns
                     //var rowsdata = this.drilldowndata.rowsdata
                     console.log("Post API Called",this.string)
                     }, err => {
                         console.log('Error Fetching data', err)
                         })
                 }*/

    }
  }
}
</script>
<style scope>
th {
  font-size: 12px;
}
.grid-container {
  overflow-y: auto;
  height: 500px;
}
td  {
  text-align: left;
}

.error
{
    color: Red;
    visibility: hidden;
}
</style>